import { render } from "./OutageInAreaDialog.vue?vue&type=template&id=63a8af8e"
import script from "./OutageInAreaDialog.vue?vue&type=script&lang=js"
export * from "./OutageInAreaDialog.vue?vue&type=script&lang=js"

import "./OutageInAreaDialog.vue?vue&type=style&index=0&id=63a8af8e&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__